// extracted by mini-css-extract-plugin
export default {"actionsWrapper":"trainings_actionsWrapper__E-TV6","actionLabel":"trainings_actionLabel__JqLWv","action":"trainings_action__dwk4A","trainingsList":"trainings_trainingsList__h3DoE"};